import request from '@/router/axios'
import store from '@/store'
import { baseUrl } from '@/config/env'

/**
 * 上传文件(写数据库)
 * @param {File} file
 * @param {String} dir 文件路径。开头不加“/”，结尾需要加“/”
 */
export const uploadFile = (file, dir = 'ultralab/') => {
    let data = new FormData(); // FormData 对象
    data.append('file', file); // 文件对象
    if (dir) {
        data.append("dir", dir)
    }
    return request('/api/file/uploadFile', {
        data
    }, 'post');
}

/**
 * 根据uid获取文件信息
 * @param {String} uid 文件uid
 */
export const getFileUrlByUid = uid => {
    return `${baseUrl}/api/file/getFileByUid?token=${store.getters.token}&uid=${uid}`
}

/**
 * 根据annexUid下载作业附件
 */
export const getFileInfoByUid = uid => {
    return request(`/api/file/document/info/${uid}`);
}

/**
 * 作业打包
 * @param uid
 */
export const packTaskFile = uid => {
    return request(`/api/file/task/${uid}/zipFiles`);
}

/**
 * 实验打包
 * @param uid
 */
export const packExpFile = uid => {
    return request(`/api/file/exp/${uid}/zipFiles`);
}

export function packExpWordFile(uid) {
    return request(`/api/file/exp/${uid}/zipWordFiles`);
}
